import Pagination from 'semantic-ui-react/dist/es/addons/Pagination';

export default Pagination;
